module.exports = __webpack_public_path__ + "img/export_blue.642ea2ac.svg";